var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-edit"},[_c('edit',{attrs:{"fs":_vm.pageFields,"id":_vm.id,"api":"pages","title":"Pages"},on:{"changed":_vm.changed,"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }